var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkExternal = function SvgLinkExternal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1677FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13.875 5.875v-4.25m0 0h-4.25m4.25 0L7.5 8M6.083 1.625H4.525c-1.19 0-1.785 0-2.24.232-.4.203-.725.528-.928.928-.232.455-.232 1.05-.232 2.24v5.95c0 1.19 0 1.785.232 2.24.203.4.528.725.928.928.455.232 1.05.232 2.24.232h5.95c1.19 0 1.785 0 2.24-.232.4-.203.725-.528.928-.928.232-.455.232-1.05.232-2.24V9.417"
  })));
};
export default SvgLinkExternal;